$(document).ready(function() {

    $(window).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
    });

    window.addEventListener("pageshow", function ( event ) {
        var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
        if(historyTraversal ) {
          window.location.reload();
        }
    });
 
   function empty_sel() {
      $(document).find('.itg_comic').removeClass("comic_first");
      $(document).find('.select_item_type__grid .select_item_type__item').removeClass("select_item_type__item_active");
      $(document).find(".select_photo_item").removeClass("select_photo_item_active");
      $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
      $(document).find('#tmp-28_checkbox').prop('checked', false);
      $(document).find(".photo_id_button").text('');
      $(document).find("#ink_color").attr('name','');
      $(document).find("#ink_color").val('');
      $(document).find("#itg_properties_data").html('');
      $(document).find('.itg_disable_find').addClass('itg_disable_items');
      $(document).find('#choose_photo').val('');
      $(document).find('#valid_btn_submit').addClass('btn_check_status');
      $(document).find('.autograph_add_ons_wrapper').addClass('itg_autograph_add_ons_wrapper');
      $(document).find(".photo_uploaded_successfully").css("display", "none");
      $(document).find(".choose_photo_remove").css("display", "none");
      $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
      $(document).find(".select_ink_color_heading").text('Select Ink Color');
      $(document).find(".select_ink_color_label").removeClass("drop_down_active");
      $(document).find(".custom_color_ink").removeClass("drop_down_active");
      $(document).find("#ink_color").attr('name','');
      $(document).find("#ink_color").val('');
      $(document).find("#custom_ink_color").val('');
      $(document).find(".existing_signet_order_label").removeClass("check_caste_piece drop_down_active");
      $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
      $(document).find('#funko_pop_flat').removeClass('steps_box_grid_funko_pop_active');
      $(document).find('#heading_cast_price').hide();
      $(document).find('#heading_cast_price').attr('data-set','0');
      $(document).find('#field_detailed_description').attr('name','');
      $(document).find('#field_detailed_description').val('');
      $(document).find('.step_box_disclaimer').hide();

          
          /* ---------- */
             $(document).find(".send_in_item_type_heading").text('Select your item');
             $(document).find(".itg_box_grid").each(function(index) {
                $(this).removeClass('steps_box_grid_active');
             });
             $(document).find("ul#signet_order_type_items li").each(function(index) {
                $(this).removeClass('drop_down_active');
             });
            $(document).find('.personal_pro').remove();
            $(document).find("ul.steps_box_grid_tranding_cards").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_comix_book_or_magazine").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_tranding_cards li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
            $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
           /* ---------- */
     
   }
   function addons_check() {
       $(document).find(".add_on__head .add_on_name_head").each(function() {
          $(this).find('.promoted-input-checkbox').prop('checked', false);
          $(this).find('.itg_add_on_field').removeClass('add_on_field_active');
          $(this).find('.itg_add_on_field').attr('name','');
          $(this).find('.itg_add_on_field').val('');
       });
       $(document).find('#field_location').attr('name','');
       $(document).find('#field_location').val('');
     
   }
   function defult_cal() {
      var totalPrice = 0;
      var main_symbol = $(document).find('.itg_main_product_temp').attr('data-sym');
      totalPrice += parseFloat($(document).find('.itg_custom_price').attr('data-mainprice').toString().replace(/,/g, ''));
      $(document).find(".itg_custom_price").text(main_symbol+totalPrice.toFixed(2));
      $(document).find(".itg_custom_price").attr('data-orignalprice',totalPrice.toFixed(2));
   }
   function cal_price(addprice) {
       var totalPrice = 0;
       var main_symbol = $(document).find('.itg_main_product_temp').attr('data-sym');
       totalPrice += parseFloat($(document).find('.itg_custom_price').attr('data-mainprice').toString().replace(/,/g, ''));
       var funkoPrice = $(document).find('li.funko_pop_grid_item.funko_pop_grid_item_active').attr('data-funko');
         if(funkoPrice){
           totalPrice += parseFloat(funkoPrice.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       var selPhoto = $(document).find('#choose_photo').val();
         if(selPhoto){
           
           var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-price'); 
           totalPrice += parseFloat(photosizePrice.toString().replace(/,/g, ''));
           
           totalPrice += parseFloat($(document).find('#choose_photo').attr('upload-price').toString().replace(/,/g, ''));
           
         }else{
             var photo_id_price = $(document).find(".photo_id_button").text();
             if(photo_id_price){
               var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-price');
               totalPrice += parseFloat(photosizePrice.toString().replace(/,/g, ''));
             }else{
               totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
             }
         }
       $(document).find(".itg_checkbox_price:checked").each(function() {
         var adone_val = $(this).attr('data-addons');
         if(adone_val){
           totalPrice += parseFloat(adone_val.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       });

       var castePiece = $(document).find('.check_caste_piece').attr('item-caseprice');
       if(castePiece){
          totalPrice += parseFloat(castePiece.toString().replace(/,/g, ''));
       }else{
         totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
       }

       var castePiece_funko = $(document).find('.steps_box_button_active').attr('data-flat');
       if(castePiece_funko){
          totalPrice += parseFloat(castePiece_funko.toString().replace(/,/g, ''));
       }else{
         totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
       }

       var add_castePiece = $(document).find('#heading_cast_price').attr('data-set');
       if(add_castePiece == 1){
           $(document).find('#itg_properties_data input[name="properties[Adding Cast Piece]"]').remove();
           var add_castePiece_cal = $(document).find('#heading_cast_price').attr('data-setprice');
           var adding_price = add_castePiece_cal;
           totalPrice += parseFloat(add_castePiece_cal.toString().replace(/,/g, ''));
           $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="properties[Adding Cast Piece]" value="${adding_price}">`);
       }else{
         totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         $(document).find('#itg_properties_data input[name="properties[Adding Cast Piece]"]').remove();
       }

       var signet_cast_price = $(document).find('.signet_cast_price').attr('item-caseprice');
       if(signet_cast_price){
          totalPrice += parseFloat(signet_cast_price.toString().replace(/,/g, ''));
       }else{
         totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
       }

       $(document).find("ul.steps_box_grid_tranding_cards li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       });
       $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       });
       $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       });

       $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val.toString().replace(/,/g, ''));
         }else{
           totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
         }
       });

       // comic price selection  cgc price js start
        var $comicButton = $('button.comic_steps_box_button.itg_comic.comic_first');
        if ($comicButton.length > 0 && $comicButton.hasClass('comic_first')) {
          var cgcPriceSelect = $comicButton.attr('data-boxprice');
          if (cgcPriceSelect != 0) {
            totalPrice += parseFloat(cgcPriceSelect.toString().replace(/,/g, ''));
          } else {
            totalPrice += parseFloat(addprice.toString().replace(/,/g, ''));
          }
        }
       // comic price selection  cgc price js end
      

      var finalval = parseFloat(totalPrice.toString().replace(/,/g, ''));
      $(document).find(".itg_custom_price").text(main_symbol + finalval.toFixed(2));
      $(document).find(".itg_custom_price").attr('data-orignalprice', finalval.toFixed(2));
   }

  //Start-same_data
      $(document).on("click", ".select_ink_color_heading_head", function () {
          $(".select_ink_color_label,.custom_color_ink").toggleClass("drop_down_active");
      });
      $(document).on("click", ".select_ink_color_label", function () {
         $(document).find(".select_ink_color_heading").text($(this).text());
         $(document).find(".select_ink_color_label").removeClass("drop_down_active");
         if(!$('.select_ink_color_label').hasClass('drop_down_active')){
            $(".custom_color_ink").removeClass("drop_down_active");
         }
         $(document).find("#custom_ink_color").val('');
         var ink_name = $(this).attr('ink-name');
         $(document).find("#ink_color").attr('name','properties[Ink Color]');
         $(document).find("#ink_color").val(ink_name);
      });
     $(document).on("click", "#custom_ink_color_btn", function () {
         var colorInput = $(this).closest('.custom_color_ink').find('#custom_ink_color').val();
        console.log(colorInput) ;
         if(colorInput){
            $(document).find(".select_ink_color_heading").text(colorInput);
            $(document).find(".select_ink_color_label").removeClass("drop_down_active");
            $(document).find(".custom_color_ink").removeClass("drop_down_active");
            $(document).find("#ink_color").attr('name','properties[Ink Color]');
            $(document).find("#ink_color").val(colorInput);
            $(this).closest(".custom_color_ink").addClass("active-link-color");
         }else{
           alert('Enter color name');
           return false;
         }
      });
      $(document).find(".add_on__head_fields").each(function() {
        let checkbox = $(this).find(".promoted-input-checkbox");
        let addOnField = $(this).find(".add_on_field");
        if(checkbox.length && addOnField.length){
          checkbox.on("change", function () {
            addOnField.toggleClass("add_on_field_active", checkbox.is(":checked"));
             if($(this).is(':checked')){
               cal_price(addprice = 0);
             }else{
               
                $(addOnField).attr('name','');
                $(addOnField).val('');
                let thsPro = $(addOnField).attr('data-pro');
                $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                cal_price(addprice = 0);
             }
          });
        }
       });
       $(document).on("change keyup input","#character_name",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){ 
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
              var words = inputVal.trim().split(/\s+/);
              if (words.length > 2) {
                var thsword = words.slice(0, 2).join(' ');
                $(this).val(thsword);
                $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${thsword}">`);
              }
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#quote",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
                //var addStr = '-$'+thsPrice;
                $(this).val(inputVal);
                $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               var words = inputVal.trim().split(/\s+/);
                if (words.length > 8) {
                    var thsword = words.slice(0, 8).join(' ');
                    $(this).val(thsword);
                    $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                    $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${thsword}">`);
                }
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#personalization_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });

    //  $(document).on("change keyup input",".personalization_auto",function() {
    //         var inputVal = $(this).val();
    //         var thsPro = $.trim($(this).attr('data-pro'));
    //         if(inputVal){
    //            var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
    //            //var addStr = '-$'+thsPrice;
    //            $(this).val(inputVal);
    //            $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
    //            $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
    //         }else{
    //           $(this).val('');
    //           $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
    //         }
    //         cal_price(addprice = 0);
    //    });
       
      $(document).on("change keyup input","#remarque_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
      
      
      $(document).on("change keyup input","#headshot_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });

       $(document).on("change keyup input","#bust_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });

       $(document).on("change keyup input","#full_body_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
    
  
       $(document).on("change keyup input","#field_location",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
             $(this).attr('name',thsPro);
              $(this).val(inputVal);
            }else{
              $(this).attr('name','');
              $(this).val('');
            }
            cal_price(addprice = 0);
       });
  //End-same_data
  
   function signet_items() {
          /* Start-what-type-of-item-would-you-like-to-order */
          $(document).on("click",".select_item_type__grid .select_item_type__item",function() {
               $(document).find('.itg_disable_find').addClass('itg_disable_items');
               $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
               $(document).find(".select_ink_color_heading").text('Select Ink Color');
			   $(document).find("#ink_color").attr('name','');
			   $(document).find("#ink_color").val('');
			   $(document).find("#custom_ink_color").val('');
                $(document).find('.itg_comic').removeClass("comic_first");
            
               $(document).find('.select_item_type__grid .select_item_type__item').removeClass("select_item_type__item_active");
               $(this).addClass('select_item_type__item_active');
               let itemTypeValue = $(this).attr("item-type");
               
               $(document).find(".item_type_content").each(function() {
                 let itemContentValue = $(this).attr("item-type-content");
                 $(this).toggleClass("item_type_content_active", itemTypeValue === itemContentValue);
                 $(this).removeClass("itg_disable_items", itemTypeValue === itemContentValue);
               });
               $(document).find(".select_photo_item").removeClass("select_photo_item_active");
               $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
               $(document).find(".photo_id_button").text('');
               if(itemTypeValue == 'comic-book' || itemTypeValue == 'Comic-Book'){
                 $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${itemTypeValue}">`);
               }else if(itemTypeValue == 'book' || itemTypeValue == 'books'){
                 $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                 $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                 $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${itemTypeValue}">`);
               }else{
                 $(document).find(`#itg_properties_data input[name="properties[Order Type]"]`).remove();
                 $(document).find('#valid_btn_submit').addClass('btn_check_status');
               }
               cal_price(addprice = 0);
          });
         /* End-what-type-of-item-would-you-like-to-order */
     
         /* Start-what-photo-size-would-you-like */
               $(document).on("click","ul.select_photo_size_price_grid li.select_photo_item",function() {
                     
                     $(document).find(".photo_uploaded_successfully").css("display", "none");
                     $(document).find(".choose_photo_remove").css("display", "none");
                     $(document).find(".select_photo_item").removeClass("select_photo_item_active");
                     $(this).addClass('select_photo_item_active');
                     $(document).find(".photo_from_gallery_head").addClass("photo_gallery_popup");
                     //let itemSize = $.trim($(this).attr("item-size"));
                     let itemSize = $.trim($(this).attr("item-sizesel"));
                     $(document).find(".photo_from_gallery_inner").each(function() {
                       let photoGalleryInnerValue = $(this).attr("gallery-photo");
                       $(this).toggleClass("photo_gallery_inner_active", itemSize === photoGalleryInnerValue);
                     });
                     $(document).find(".photo_id_button").text('');
                     $(document).find('#choose_photo').val('');
                     $(document).find("#main_photo_artwork").css("display", "none");
                     $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                     $(document).find(".select_ink_color_heading").text('Select Ink Color');
                     $(document).find(".select_ink_color_label").removeClass("drop_down_active");
                     $(document).find(".custom_color_ink").removeClass("drop_down_active");
      			     $(document).find("#ink_color").attr('name','');
      			     $(document).find("#ink_color").val('');
      			     $(document).find("#custom_ink_color").val('');
                     $(document).find('#valid_btn_submit').addClass('btn_check_status');
                     cal_price(addprice = 0);
               });
               $(document).on("click",".itg_photo_from_gallery__item",function() {
                 var ths_id = $(this).attr('data-imgid');
                 $(document).find(".photo_id_button").text(ths_id);
                 $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
                   if(ths_id){
                     $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                     $(document).find("#itg_properties_data").html('');
                     $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                     var orderType = $(document).find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
                     var photoSize = $.trim($(document).find('li.select_photo_item.select_photo_item_active').attr('item-size'));
                     //var photoSize_pro = $(document).find('li.select_photo_item.select_photo_item_active').attr('item-selpro');

                     let anotherOrderType = $('.order_type_list_label.custom_select_option_label.check_order_type').attr("type-name");

                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Choose Order]" value="${anotherOrderType}">`);
                     
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${orderType}">`);
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo Size]" value="${photoSize}">`);
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo ID]" value="${ths_id}">`);
                      cal_price(addprice = 0);
                   }
               });
               $(document).on("click",".itg_upload_your_image",function() {
                   $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                   $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			   $(document).find("#ink_color").attr('name','');
    			   $(document).find("#ink_color").val('');
    			   $(document).find("#custom_ink_color").val('');
                   $(document).find("#main_photo_artwork").css("display", "block");
                   $(document).find(".photo_id_button").text('');
                   $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
                   let heightFromBodyToDiv = $(document).find('#main_photo_artwork').height();
                   $('html, body').animate({
                      scrollTop: $('#main_photo_artwork').offset().top - heightFromBodyToDiv
                   }, 'slow');
                   cal_price(addprice = 0);
               });
               $(document).on("click",".available_photos_btn",function() {
                   $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                   $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			   $(document).find("#ink_color").attr('name','');
    			   $(document).find("#ink_color").val('');
    			   $(document).find("#custom_ink_color").val('');
                   $(document).find('#choose_photo').val('');
                   $(document).find("#itg_properties_data").html('');
                   $(document).find("#main_photo_artwork").css("display", "none");
                   $(document).find(".photo_id_button").text('');
                   let heightFromBodyToDiv = $(document).find('.select_photo_size_price_head').height();
                   $('html, body').animate({
                      scrollTop: $('.select_photo_size_price_head').offset().top - heightFromBodyToDiv
                   }, 'slow');
                   $(document).find('#valid_btn_submit').addClass('btn_check_status');
                   cal_price(addprice = 0);
               });
               $(document).on("click",".cross-icon",function() {
                  $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
               });
               $(document).on("change", "#choose_photo", function(){
                if($(this).val() != '' ){
                    $(document).find('.addLoader').addClass('it_loading');
                    $(document).find(".photo_uploaded_successfully").css("display", "none");
                    $(document).find(".choose_photo_remove").css("display", "none");
                    var file_data = $('#choose_photo').prop('files')[0];
                    var form_data = new FormData();
                    form_data.append('image', file_data);
                     $.ajax({
                        url: "https://dev.shopifyexperthelp.com/app/project_app/file.php",
                        type: "POST",
                        data: form_data,
                        contentType: false,
                        cache: false,
                        processData:false,
                        success: function(data_new){
                           $(document).find("#itg_properties_data").html('');
                           $(document).find("#upload_photo").val(data_new);
                           $(document).find(".photo_id_button").text('PHOTOREQUEST');
                           
                           $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                           if(data_new){
                             $(document).find("#choose_photo").attr('data-imgfinal',data_new);
                             var ths_id = 'PHOTOREQUEST';
                             var orderType = $(document).find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
                             var photoSize = $.trim($(document).find('li.select_photo_item.select_photo_item_active').attr('item-size'));
                             var photoSize_pro = '$20';

                             let anotherOrderType = $('.order_type_list_label.custom_select_option_label.check_order_type').attr("type-name");

                             $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Choose Order]" value="${anotherOrderType}">`);  
                             
                             $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${orderType}">`);
                             $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo Size]" value="${photoSize}">`);
                             $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo ID]" value="${ths_id}">`);
                             $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Upload Photo]" value="${data_new}">`);
                             $(document).find(".choose_photo_remove").css("display", "inline-flex");
                             $(document).find(".photo_uploaded_successfully").css("display", "flex");
                             $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                           }
                           $(document).find('.addLoader').removeClass('it_loading');
                           cal_price(addprice = 0);
                        },
                        error: function(){} 	        
                      });
                }
           });
             $(document).on("click",".choose_photo_remove",function() {
                $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                 $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			 $(document).find("#ink_color").attr('name','');
    			 $(document).find("#ink_color").val('');
    			$(document).find("#custom_ink_color").val('');
                $(document).find('#choose_photo').val('');
                $(document).find(".photo_id_button").text('');
                $(document).find(".photo_uploaded_successfully").css("display", "none");
                $(document).find('#valid_btn_submit').addClass('btn_check_status');
                $(document).find(".choose_photo_remove").css("display", "none");
                cal_price(addprice = 0);
             });
         /* End-what-photo-size-would-you-like */
     
         /* Start-funko-pop-poster */
           $(document).on("click",".funko_pop_grid_item",function() {
                $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                $(document).find("#itg_properties_data").html('');
                $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
                $(this).addClass("funko_pop_grid_item_active");
                //var addprice = $(this).attr("data-funko");
                $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                var orderType = $(document).find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
                var funkoName = $(this).attr("data-funkoname");
                var preorderName = $(this).attr("data-productTypes");
                var funkoName__pro = $(this).attr("item-selpro");
                let anotherOrderType = $('.order_type_list_label.custom_select_option_label.check_order_type').attr("type-name");

                $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Choose Order]" value="${anotherOrderType}">`); 
                $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${orderType}">`);
                if (preorderName == 'pre_order_addon') {
                  $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Preorder Name]" value="${funkoName}">`);
                }else{
                  $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Funko Name]" value="${funkoName}">`);
                }
                cal_price(addprice = 0);
           });
         /* End-funko-pop-poster */
   }

   function signet_existing_order() {
        $(document).find('#valid_btn_submit').addClass('btn_check_status');
        $(document).find("#itg_properties_data").html('');
        $(document).find(".existing_signet_order_head").addClass("itg_disable_items");
        $(document).find(".existing_signet_order_heading").text('Select your item');
        $(document).on("change keyup input","#field_name_order_number",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            if(inputVal){
              $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);
              $(document).find(".existing_signet_order_head").removeClass("itg_disable_items");
            }else{
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find(".existing_signet_order_head").addClass("itg_disable_items");
               $(document).find(".existing_signet_order_heading").text('Select your item');
               $(document).find(".existing_signet_order_label").removeClass("check_caste_piece");
               $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
               $(document).find('#funko_pop_flat').removeClass('steps_box_grid_funko_pop_active');
               $(document).find(".existing_signet_order_label").removeClass("drop_down_active");
                     $(document).find("#ink_color").attr('name','');
      			     $(document).find("#ink_color").val('');
                     $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                     $(document).find(".select_ink_color_heading").text('Select Ink Color');
                     $(document).find("#custom_ink_color").val('');
                     $(document).find(".custom_color_ink").removeClass("drop_down_active");
            }
            cal_price(addprice = 0);
        });
        
         /* startWhat type of item is your caste piece? */
           $(document).on("click",".itg_steps_box_grid_item_buttons .steps_box_button",function() {
               $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
               $(this).addClass('steps_box_button_active');
               $(document).find('.step_box_disclaimer').show();
               cal_price(addprice = 0);
               var funkopopup_flat_name = $(this).attr('data-name');
               if(funkopopup_flat_name){
                 var funkopopup_flat_val = $(this).attr('data-flatname');
                 //$(document).find(`#itg_properties_data input[name="${funkopopup_flat_name}"]`).remove();
                 //$(document).find("#itg_properties_data").append(`<input type="hidden" name="${funkopopup_flat_name}" value="${funkopopup_flat_val}">`);
               }
           });
         /* end-What type of item is your caste piece? */
   }
     //Start-select-item-signet_existing_order
      if($(document).find('.existing_signet_order_heading_head').length > 0){
          $(document).on("click",".existing_signet_order_heading_head",function() {
            $(document).find(".existing_signet_order_label").toggleClass("drop_down_active");
         });
         $(document).on("click",".existing_signet_order_label",function() {

           // additional charge add on js
          
           if($(".additional_charge_add_on #additional_charge_checkbox").is(":checked")) {
             $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false) ;
           }

          // additional charge add on js
           
            //$(document).find(".existing_signet_order_label").removeClass("drop_down_active check_caste_piece");
            $(document).find('.step_box_disclaimer').hide();
            $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
            $(".existing_signet_order_label").removeClass("drop_down_active check_caste_piece");
            $(this).addClass('check_caste_piece');
            $(document).find(".existing_signet_order_heading").text($(this).text());
            
            var thsPro = $.trim($(this).attr('data-name'));
            var inputVal = $.trim($(this).attr('data-title'));
            var splitValue = inputVal.split('-');
            var inputVal = splitValue[0];
            $(document).find(`#itg_properties_data input[name="properties[Funko POP Sent]"]`).remove();
            $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);
           
            if($(this).hasClass("stepbox_funko_pop")) {
              $(document).find(".send_in_item_type_head").addClass("send_in_item_type_head_active");
              $(document).find(".existing_signet_order_head").addClass("existing_signet_order_head_active");
              $(document).find(".steps_box_grid_funko_pop").addClass("steps_box_grid_funko_pop_active");
            }else{
              $(document).find(".send_in_item_type_head").removeClass("send_in_item_type_head_active");
              $(document).find(".existing_signet_order_head").removeClass("existing_signet_order_head_active");
              $(document).find(".steps_box_grid_funko_pop").removeClass("steps_box_grid_funko_pop_active");
            }
            $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
            cal_price(addprice = 0);
            $(document).find('#valid_btn_submit').removeClass('btn_check_status');
         });

         
      }
   //End-select-item-signet_existing_order

      //Start-Please-Provide-a-detailed-description-of-youritem
       $(document).on("change keyup input","#field_detailed_description",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
              $(this).attr('name',thsPro);
              $(this).val(inputVal);
            }else{
              $(this).attr('name','');
              $(this).val('');
            }
            cal_price(addprice = 0);
       });
     //End-Please-Provide-a-detailed-description-of-youritem

    function signet_order_type() {
        //console.log('Test Data');
    }

    if($(document).find('.comic_books').length > 0){
       $(document).on('click','.comic_books .itg_comic',function() {
          $(document).find('.itg_comic').removeClass('comic_first');
          $(this).addClass('comic_first');
          var thsPrice = $(this).attr('data-boxprice');
          var thsPro = 'properties[Comic Book]';
          var inputVal = 'Comic Book CGC Encapsulation';
          $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
          if(thsPrice != 0){
            $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
          }
          $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
          $(document).find('#valid_btn_submit').removeClass('btn_check_status');
          cal_price(addprice = 0);
       });
    }
   //Start-select-item-signet_order_type
     if($(document).find('.send_in_item_type_heading_head').length > 0){
        $(document).on('click','.send_in_item_type_heading_head',function() {
          $(document).find(".send_in_item_type_label").toggleClass("drop_down_active");
        });
        $(document).on('click','.send_in_item_type_label',function() {

             
          // additional charge add on js
          
           if($(".additional_charge_add_on #additional_charge_checkbox").is(":checked")) {
             $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false) ;
           }

          // additional charge add on js
          
           /* ---------- */
           $(document).find('.personal_pro').remove();
            $(document).find("ul.steps_box_grid_tranding_cards").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_comix_book_or_magazine").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_tranding_cards li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
            $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
           /* ---------- */
          
            $(document).find(".send_in_item_type_label").removeClass("drop_down_active");
            $(document).find(".steps_box_grid").removeClass("steps_box_grid_active");
            $(document).find(".send_in_item_type_head").removeClass("send_in_item_type_head_active");
            $(document).find(".send_in_item_type_heading").text($(this).text());
          
              if($(this).hasClass("stepbox_trading_cards")) {
                $(document).find(".steps_box_grid_tranding_cards").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_comix_book_or_magazine")) {
                $(document).find(".steps_box_grid_comix_book_or_magazine").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_funko_pop")) {
                $(document).find(".steps_box_grid_funko_pop").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_photo_and_flats_larger_than")) {
                $(document).find(".steps_box_grid_photo_and_flats_larger_than").addClass("steps_box_grid_active");
              }
          
              if ($(document).find('.steps_box_grid').hasClass("steps_box_grid_active")) {
                $(document).find(".send_in_type_select_option_steps_warpper").addClass("send_in_type_select_option_steps_active");
              }else{
                $(document).find(".send_in_type_select_option_steps_warpper").removeClass("send_in_type_select_option_steps_active");
              }
          
              $(document).find('ul#signet_order_type_items li').removeClass('signet_cast_price');
              $(this).addClass('signet_cast_price');

              var thsPro = $.trim($(this).attr('data-name'));
              var inputVal = $.trim($(this).attr('data-title'));
              var splitValue = inputVal.split('-');
              var inputVal = splitValue[0];
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
              $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);

              $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
              cal_price(addprice = 0);
              $(document).find('#valid_btn_submit').removeClass('btn_check_status');
        }); 

        /*Start-Trading-Cards */
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_first_trade',function() {
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(this).addClass('trade_active_first');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[Slab-Crack]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_2').show();
               if(thsPrice != 0){
                  $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                  $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_second_trade',function() {
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(this).addClass('trade_active_second');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Encapsulation]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
               }else{
                 //$(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 //$(document).find(`#itg_properties_data input[name="properties[CGC Pressing]"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').hide();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').attr('data-cprice','0');
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3 .step_third_trade').removeClass('trade_active_third');
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_third_trade',function() {
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(this).addClass('trade_active_third');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Pressing]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
               //$(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
         });
        /*End-Trading-Cards */

        /*Start-Comix-book-or-magazine*/
          $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_first_book',function() {
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(this).addClass('book_active_first');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_2').show();
               var thsPro = 'properties[Slab-Crack]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_second_book',function() {
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(this).addClass('book_active_second');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Encapsulation]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                  $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                  $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`)
                  $(this).closest('li').find('.steps_box_grid_item_price_added').show();
                  $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find(`#itg_properties_data input[name="properties[CGC Pressing]"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').hide();
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').attr('data-cprice','0');
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3 .step_third_book').removeClass('book_active_third');
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_third_book',function() {
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(this).addClass('book_active_third');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Pressing]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
               //$(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
         });
        /*End-Comix-book-or-magazine*/
       
        /* Start-Funko-POP */
          $(document).on('click','ul.itg_sending_steps_box_grid_funko_pop button',function() {
               $(document).find('ul.itg_sending_steps_box_grid_funko_pop button').removeClass('personal_active');
               $(this).addClass('personal_active');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(this).closest('li').find('.step_box_disclaimer').show();
               var thsPro = 'properties[Funko Pop]';
               var inputVal = $.trim($(this).attr('data-boxname'));
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               cal_price(addprice = 0);
          });
        /* End-Funko-POP */
       
        /* Start-Photo-and-flats-larger */
          $(document).on('click','ul.steps_box_grid_photo_and_flats_larger_than button',function() {
               $(document).find('ul.steps_box_grid_photo_and_flats_larger_than button').removeClass('personal_active');
               $(this).addClass('personal_active');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(this).closest('li').find('.step_box_disclaimer').show();
               var thsPro = 'properties[Photo Flat]';
               var inputVal = $.trim($(this).attr('data-boxname'));
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               cal_price(addprice = 0);
          });
        /* End-Photo-and-flats-larger */
         
     }
   //End-select-item-signet_order_type

   if($(document).find(".order_type_wrapper").length > 0) {
      $(document).on("click", ".order_type_heading_head", function () {
          $(".order_type_list_label").toggleClass("drop_down_active");
      });
      $(document).on("click", ".order_type_list_label", function () {
          addons_check();
          defult_cal();
          empty_sel();
          $(document).find('#heading_cast_price').hide();
          $(document).find('#heading_cast_price').attr('data-set','0');
          $(document).find('.order_type_list_label').removeClass('check_order_type');
          $(document).find(".order_type_list_label").removeClass("drop_down_active");
          $(document).find(".order_type_heading").text($(this).text());
          $(this).addClass('check_order_type');
        
          $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false);
        
          let typeLabelValue = $(this).attr("type-label");
          let orderType = $.trim($(this).attr('type-name'));
          $(document).find(".order_type_content_wrapper").each(function () {
              let typeContentValue = $(this).attr("product-content");
              $(this).toggleClass("order_type_content_active", typeLabelValue === typeContentValue);
          });
          $(".provide_a_detailed_description_head").toggleClass("provide_a_detailed_description_active",typeLabelValue === 'signet_order_type' || typeLabelValue === 'signet_existing_order');

          if(typeLabelValue == undefined)
            $(document).find(".additional_charge_add_on").removeClass("show") ;
        
          if(typeLabelValue == 'signet_items') {
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');
            $(document).find(".additional_charge_add_on").removeClass("show") ;
            signet_items();
          }
          if(typeLabelValue == 'signet_existing_order') {
            $(document).find('#heading_cast_price').show();
            $(document).find('#heading_cast_price').attr('data-set','1');
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');
            $(document).find('#field_name_order_number').val('');

            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.sending_in_personal_product").removeClass("show") ;
            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.add_to_cast_item ").addClass("show") ;
            
            signet_existing_order();
            cal_price(addprice = 0);
          }
          if(typeLabelValue == 'signet_order_type'){
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');

            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.sending_in_personal_product").addClass("show") ;
            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.add_to_cast_item").removeClass("show") ;
            
            signet_order_type();
          }

          $(document).find(`#itg_properties_data input[name="properties[Choose Order]"]`).remove();
          if(orderType){
            var thsPro = 'properties[Choose Order]';
            $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${orderType}">`);
          }
          
      });
   }

  
  // additional charge add on js

   $(".additional_charge_add_on").find("#additional_charge_checkbox").change(function() {
    
    if ($(this).is(":checked")) {

          const dataAddOnCharge = Number($(this).attr("data-addons"));

          $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Add on Upcharge]" value="$${dataAddOnCharge.toFixed(2)}">`) ; 
      
          let prevPrice = Number($(".price_container_head .itg_custom_price").attr("data-orignalprice"));
          let newPrice = (prevPrice + dataAddOnCharge).toFixed(2); // Ensures two decimal places
  
          $(".price_container_head .itg_custom_price").attr("data-orignalprice", newPrice);      
          $(".price_container_head .itg_custom_price").html(`$${newPrice}`);
          
      } else {
          const dataAddOnCharge = Number($(this).attr("data-addons"));
      
          $(document).find("#itg_properties_data input[name='properties[Add on Upcharge]']").remove(); 
      
          let prevPrice = Number($(".price_container_head .itg_custom_price").attr("data-orignalprice"));
          let originalPrice = (prevPrice - dataAddOnCharge).toFixed(2); // Ensures two decimal places
  
          $(".price_container_head .itg_custom_price").attr("data-orignalprice", originalPrice);
          $(".price_container_head .itg_custom_price").html(`$${originalPrice}`);
      
      }
  });

  // additional charge add on js
  
   $(document).on("click", "#valid_btn_submit", function () {

        var checkboxStatus = 1;
        var category1Checked = $('#character_name_checkbox:checked').length > 0;
        var category2Checked = $('#personalization_details_checkbox:checked').length > 0;
        var category3Checked = $('#quote_checkbox:checked').length > 0;
     
        var category4Checked = $(".provide_a_detailed_description_head.provide_a_detailed_description_active").length > 0  ;

        if(category4Checked == true){
          let detailedDescription =  $("#field_detailed_description").val() ;
            if(detailedDescription){
              checkboxStatus = 1 ;
            }
            else{
                checkboxStatus = 0 ;
                $(document).find('#field_detailed_description').focus();
                   $('html, body').animate({
                      scrollTop: $("#field_detailed_description").offset().top - 300
                   }, 2000);
                return false;
              }
          }

         // -----------------------ink color-------------------------
        var inkColorActive = document.querySelector('.active-link-color');

        if (inkColorActive) {
          console.log('inkColorActive:', inkColorActive);
        } else {
          $(document).find('.order_type_content_active .itg-custom-link-wrapper .custom_select_option_wrapper').css('box-shadow', '0px 0px 5px #1f4f67');
        
          
          // Animate scrolling to the second target after the first completes
          $('html, body').animate({
            scrollTop: $(".order_type_content_active .itg-custom-link-wrapper").offset().top - 350
          }, 2000);
        
          return false;
        }


        // -----------------------ink color-------------------------

     

        if(category1Checked == true){
          var character_name = $(document).find('#character_name').val();
          if(character_name){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            $(document).find('#character_name').focus();
             $('html, body').animate({
                scrollTop: $("#character_name").offset().top - 300
             }, 2000);
            return false;
          }
        }
       if(category2Checked == true){
           var personalization_details = $(document).find('#personalization_details').val();
           if(personalization_details){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            $(document).find('#personalization_details').focus();
             $('html, body').animate({
                scrollTop: $("#personalization_details").offset().top - 250
             }, 2000);
            return false;
          }
        }
       if(category3Checked == true){
          var quote = $(document).find('#quote').val();
          if(quote){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            $(document).find('#quote').focus();
            $('html, body').animate({
                scrollTop: $("#quote").offset().top - 300
             }, 2000);
            return false;
          }
        }

     if(checkboxStatus == 1){
        if($(document).find('#tmp-28_checkbox').is(':checked')) {
             $(document).find('.addLoader').addClass('it_loading');
          
             var allpro_price = $(document).find('.itg_custom_price').attr('data-orignalprice');
             if(allpro_price){
               $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[_Total Price]" value="${allpro_price}">`);
             }
          
             var random_number = $(document).find('#random_number').val();
             var itemsDataNew = {};
             itemsDataNew['items'] = [];
          
             var photo_info = $(document).find('#choose_photo').val();
             if(photo_info){
               
                   var photo_infoId = $(document).find('#choose_photo').attr('upload-id');
                   var photo_infoText = $(document).find(".photo_id_button").text();
                   var photo_upload = $(document).find('#choose_photo').attr('data-imgfinal');

                   var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-id');
               
                   itemsDataNew['items'].push({
                      id: photo_infoId,
                      quantity: 1,
                      properties: {
                         "Photo ID": photo_infoText,
                         "Upload Photo":photo_upload,
                         "_Rno":random_number,
                      }
                  });

                  itemsDataNew['items'].push({
                        id: photosizePrice,
                        quantity: 1,
                        properties: {
                          "Photo ID": photo_infoText,
                          "_Rno":random_number,
                        }
                    });
               
             }else{
                var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-id');
                if(photosizePrice){
                     var photo_infoText = $(document).find(".photo_id_button").text();
                     itemsDataNew['items'].push({
                        id: photosizePrice,
                        quantity: 1,
                        properties: {
                          "Photo ID": photo_infoText,
                          "_Rno":random_number,
                        }
                    });
                }
             }
             var funkoId = $(document).find('li.funko_pop_grid_item.funko_pop_grid_item_active').attr('data-funkoid');
             if(funkoId){
                 itemsDataNew['items'].push({
                    id: funkoId,
                    quantity: 1,
                    properties: {
                      "_Rno":random_number,
                    }
                 });
             }

             var signet_cast_id = $(document).find('.signet_cast_price').attr('data-itemid');
             if(signet_cast_id){
                itemsDataNew['items'].push({
                    id: signet_cast_id,
                    quantity: 1,
                    properties: {
                     "_Rno":random_number,
                    }
                 });
             }
             $(document).find("ul.steps_box_grid_tranding_cards li").each(function() {
                var trade_active_first = $(this).find('.trade_active_first').attr('data-tradid');
                var trade_active_second = $(this).find('.trade_active_second').attr('data-tradid');
                if(trade_active_first){
                  itemsDataNew['items'].push({
                     id: trade_active_first,
                     quantity: 1,
                     properties: {
                       "_Rno":random_number,
                     }
                 });
                }
                if(trade_active_second){
                  itemsDataNew['items'].push({
                     id: trade_active_second,
                     quantity: 1,
                     properties: {
                        "_Rno":random_number,
                      }
                 });
                }
             });
             $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function() {
                var personal_active = $(this).find('.personal_active').attr('data-pf');
                if(personal_active){
                    itemsDataNew['items'].push({
                      id: personal_active,
                      quantity: 1,
                      properties: {
                        "_Rno":random_number,
                      }
                   });
                }
             });
             $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function() {
                var personal_active1 = $(this).find('.personal_active').attr('data-fp');
                if(personal_active1){
                  itemsDataNew['items'].push({
                    id: personal_active1,
                    quantity: 1,
                    properties: {
                      "_Rno":random_number,
                    }
                 });
                }
             });

             $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function() {
                 var book_active_first = $(this).find('.book_active_first').attr('data-comixslab');
                 var book_active_second = $(this).find('.book_active_second').attr('data-comixscgc')
                 var book_active_third = $(this).find('.book_active_third').attr('data-comixspre');
                   if(book_active_first){
                     itemsDataNew['items'].push({
                       id: book_active_first,
                       quantity: 1,
                        properties: {
                           "_Rno":random_number,
                        }
                      });
                   }
                   if(book_active_second){
                      itemsDataNew['items'].push({
                         id: book_active_second,
                         quantity: 1,
                          properties: {
                           "_Rno":random_number,
                          }
                     });
                   }
                   if(book_active_third){
                      itemsDataNew['items'].push({
                         id: book_active_third,
                         quantity: 1,
                         properties: {
                           "_Rno":random_number,
                         }
                     });
                   } 
             });

             var add_castePiece = $(document).find('#heading_cast_price').attr('data-set');
             if(add_castePiece == 1){
                   var castePieceId = $(document).find('#heading_cast_price').attr('data-addcastid');
                   var castePieceText = $(document).find('#field_name_order_number').text();
                   if(castePieceId){
                      itemsDataNew['items'].push({
                         id: castePieceId,
                         quantity: 1,
                         properties: {
                          "Order Number": castePieceText,
                          "_Rno":random_number,
                         }
                     });
                   } 
             }
             var caste_reorder = $(document).find('.check_caste_piece').attr('data-itemid');
             if(caste_reorder){
                  itemsDataNew['items'].push({
                     id: caste_reorder,
                     quantity: 1,
                     properties: {
                      "_Rno":random_number,
                     }
                 });
             }
             $(document).find("ul#funko_pop_flat li").each(function() {
                var steps_box_button_active = $(this).find('.steps_box_button_active').attr('data-fpcast');
                if(steps_box_button_active){
                    itemsDataNew['items'].push({
                       id: steps_box_button_active,
                       quantity: 1,
                       properties: {
                        "_Rno":random_number,
                      }
                   });
                }
             });
             var character_name = $(document).find('#character_name').val();
             if(character_name){
                 var chrId = $(document).find('#character_name').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: chrId,
                     quantity: 1,
                     properties: {
                        "Character Name": character_name,
                         "_Rno":random_number,
                      }
                 });
             }
            
             var personal_detail = $(document).find('#personalization_details').val();
             if(personal_detail){
                 var persId = $(document).find('#personalization_details').attr('data-chr');
                 itemsDataNew['items'].push({
                    id: persId,
                    quantity: 1,
                    properties: {
                      "Personalization Details": personal_detail,
                      "_Rno":random_number,
                    }
                 });
             }
             var quote_detail = $(document).find('#quote').val();
             if(quote_detail){
                 var qoutId = $(document).find('#quote').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: qoutId,
                     quantity: 1,
                     properties: {
                        "Quote": quote_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             var remarque_detail = $(document).find('#remarque_details').val();
             if(remarque_detail){
                 var remarque = $(document).find('#remarque_details').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: remarque,
                     quantity: 1,
                     properties: {
                        "Remarque Request": remarque_detail,
                        "_Rno":random_number,
                      }
                 });
             }

             var headshot_details = $(document).find('#headshot_details').val();
             if(headshot_details){
                 var headshot = $(document).find('#headshot_details').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: headshot,
                     quantity: 1,
                     properties: {
                        "Headshot Request": headshot_details,
                        "_Rno":random_number,
                      }
                 });
             }
            
             var bust_details = $(document).find('#bust_details').val();
             if(bust_details){
                 var bust = $(document).find('#bust_details').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: bust,
                     quantity: 1,
                     properties: {
                        "Bust Request": bust_details,
                        "_Rno":random_number,
                      }
                 });
             }

             var full_body_details = $(document).find('#full_body_details').val();
             if(full_body_details){
                 var full_body = $(document).find('#full_body_details').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: full_body,
                     quantity: 1,
                     properties: {
                        "Full Body Request": full_body_details,
                        "_Rno":random_number,
                      }
                 });
             }
          
          // additional charge add on js

          let addVariantId = $(".additional_charge_add_on.show #additional_charge_checkbox").attr("data-variant-id") ;
          let add_on_upcharge_price = "$" + Number($(".additional_charge_add_on.show #additional_charge_checkbox").attr("data-addons")).toFixed(2) ;

          if($(".additional_charge_add_on").find("#additional_charge_checkbox").is(":checked")){

               if(addVariantId){
                 itemsDataNew['items'].push({
                     id: addVariantId,
                     quantity: 1,
                     properties: {
                       "Add On Upcharge": add_on_upcharge_price,
                        "_Rno":random_number,
                      }
                 });
              }
          }

           var comic_val = $(document).find('.itg_comic.comic_first').attr('data-tradid');
           if(comic_val){
               itemsDataNew['items'].push({
                   id: comic_val,
                   quantity: 1,
                   properties: {
                      "_Rno":random_number
                    }
               });
           }
           

          // additional charge add on js

        // const inputProps = {};
        // const _Rno = document.querySelector('#random_number')?.value || '';
        // inputProps._Rno = _Rno;
        
        // document.querySelectorAll('.add_on__head .add_on__head_fields').forEach(f => {
        //   const checkbox = f.querySelector('input[type="checkbox"]');
        //   const input = f.querySelector('input[type="text"]');
        //   if (checkbox?.checked && input?.value.trim()) {
        //     const match = input.dataset.pro?.match(/properties\[(.+?)\]/);
        //     if (match) {
        //       const key = match[1];
        //       inputProps[key] = input.value.trim();
        //     }
        //   }
        // });
        
        const bundleItems = JSON.stringify(itemsDataNew);
// ------- new code by (R) start---------//
          const form = document.querySelector(
          'form[data-type="add-to-cart-form"]'
        );
        const formData = new FormData(form);
        const container = document.querySelector("#itg_properties_data");

        const formProps = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+?)\]$/);
          if (match) formProps[match[1]] = value;
        }

        const allBundleProps = {};
        itemsDataNew.items.forEach((item) => {
          Object.entries(item.properties || {}).forEach(([key, value]) => {
            allBundleProps[key] = value;
          });
        });

         const getInfo = () => {
            const ua = navigator.userAgent;
            const platform = navigator.platform.toLowerCase();
          
            const os = /win/.test(platform)
              ? "Windows"
              : /mac/.test(platform)
              ? "macOS"
              : /linux/.test(platform)
              ? "Linux"
              : /android/i.test(ua)
              ? "Android"
              : /iphone|ipad|ipod/i.test(ua)
              ? "iOS"
              : "Unknown";
          
            const osVersionMatch = ua.match(/(Windows NT|Mac OS X|Android|CPU (iPhone )?OS)\s([0-9_\.]+)/i);
            const osVersion = osVersionMatch ? osVersionMatch[3].replace(/_/g, ".") : "Unknown";
          
            const browserMatch = ua.match(/(Edg|Chrome|CriOS|Firefox|Safari|MSIE|Trident)\/?\s?([0-9.]+)/i);
            let browser = "Unknown", browserVersion = "Unknown";
          
            if (browserMatch) {
              const name = browserMatch[1];
              browserVersion = browserMatch[2];
              if (/edg/i.test(name)) browser = "Edge";
              else if (/crios|chrome/i.test(name)) browser = "Chrome";
              else if (/firefox/i.test(name)) browser = "Firefox";
              else if (/safari/i.test(name)) browser = "Safari";
              else if (/msie|trident/i.test(name)) browser = "IE";
            }
          
            return {
              os,
              osVersion,
              browser,
              browserVersion
            };
          };
           const userInfo = getInfo(); 

        Object.entries(allBundleProps).forEach(([key, value]) => {
          const existingInput = container.querySelector(
            `input[name="properties[${key}]"]`
          );

          if (existingInput) {
            if (!existingInput.value.trim() || existingInput.value !== value) {
              existingInput.value = value;
              existingInput.classList.add("corrected-from-bundle");
            }
            

            if (container && userInfo) {
              let existingInput = container.querySelector(`input[name="properties[_device]"]`);
              const deviceInfo = `${userInfo.os} (${userInfo.osVersion}) /${userInfo.browser} (${userInfo.browserVersion})`;            
              if (!existingInput) {
                const newInput = document.createElement("input");
                newInput.type = "hidden";
                newInput.name = "properties[_device]";
                newInput.value = deviceInfo;
                container.appendChild(newInput);
              } else if (existingInput.value !== deviceInfo) {
                existingInput.value = deviceInfo; 
              }
            }
          } else {
            const newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = `properties[${key}]`;
            newInput.value = value;
            container.appendChild(newInput);

          }
        });
// ------- new code by (R) End---------//
          
             fetch('/cart/add.js', {  
                  method: 'POST',  
                  headers: {
                   'Content-Type': 'application/json',
                  },
                  body: bundleItems,
              }).then(response => {  
                  if (!response.ok) { }  
                  return response.json();  
              }).then(data => { 
               
                setTimeout(function() {
                    $(document).find('.itg_orignal_btn').trigger('click');
                    $(document).find('.addLoader').removeClass('it_loading');
                  }, 1000);
              }).catch(error => {
                  //alert('There was a problem with the fetch operation:', error);
              });

        }else {
          alert("You must acknowledge that all details from above accurately reflect the item you are pre-ordering.");
          return false;
        }
     }

   });
  
});

 var checkButtons = document.querySelectorAll(".select_ink_color_label");

checkButtons.forEach(function(checkButton) {
  checkButton.addEventListener("click", function(event) {
    console.log('checkButton clicked');
    event.target.classList.add("active-link-color");
  });
});


// Get the element with the class 'select_ink_color_wrapper'
var addcustom = document.querySelector('.item_from_signetstore_wrapper .select_ink_color_wrapper');

if (addcustom) {
  // addcustom.classList.add("link-wrapper-custom");
   addcustom.classList.add("itg-custom-link-wrapper");
  //console.log('Class added successfully!');
} else {
  //console.log('Element not found.');
}
